import React, { FC } from 'react';
//devextreem
import { Popup } from 'devextreme-react/popup';

import ModalFooter from '../../../../../../components/appModalFooter';
import { useDeleteCashFlowItemMutation } from '../../../../../../bus/cash';

type Props = {
  id: number | string | null;
  visible: boolean;
  changeVisible: (visible: boolean) => void;
  refresh: () => void;
};

const CashItemDeleteModal: FC<Props> = ({ changeVisible, id, refresh, visible }) => {
  const [deleteCashFlowItem, { isLoading }] = useDeleteCashFlowItemMutation();

  const handleSubmit = async (e: any) => {
    e.preventDefault && e.preventDefault();
    id && (await deleteCashFlowItem({ id }));
    refresh();
    changeVisible(false);
  };

  return (
    <div>
      <Popup
        visible={visible}
        onHiding={() => changeVisible(false)}
        dragEnabled={true}
        closeOnOutsideClick={false}
        showTitle={true}
        title="Подтвердите действие"
        width={400}
        height={160}
      >
        <div className="modal-block">
          <form onSubmit={handleSubmit}>
            <div className="modal-block__content">Вы действительно хотите удалить?</div>

            <ModalFooter
              useSubmitBehavior={false}
              handleSubmit={handleSubmit}
              hideModal={() => changeVisible(false)}
              textConfirm="Удалить"
              typeConfirm="danger"
              disabledSubmit={isLoading}
            />
          </form>
        </div>
      </Popup>
    </div>
  );
};

export default CashItemDeleteModal;
